import axios from "axios";

export default {
  // 加载绘制区域
  loadMap: (data) => {
    return axios
      .request({
        url: "api/postal/getAreas/" + data,
        method: "get",
      })
      .then((res) => {
        return res.data;
      });
  },
  // 新增绘制区域
  addArea: (data) => {
    return axios
      .request({
        url: "api/postal/addArea",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 修改绘制区域
  updateArea: (data) => {
    return axios
      .request({
        url: "api/postal/updateArea",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 删除绘制区域
  removeArea: (data) => {
    return axios
      .request({
        url: "api/postal/removeArea/" + data,
        method: "get",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 单个绘制区域详情
  areaDetail: (data) => {
    return axios
      .request({
        url: "api/postal/areaDetail/" + data,
        method: "get",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 新建地图
  addRegion: (data) => {
    return axios
      .request({
        url: "api/postal/addRegion/",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 获取所有地图
  getAllRegions: () => {
    return axios
      .request({
        url: "api/postal/getAllRegions",
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
  // 获取可创建地图类型
  getPostalType: () => {
    return axios
      .request({
        url: "api/postal/getPostalType",
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
  // 获取分部
  getBranches: () => {
    return axios
      .request({
        url: "api/postal/getBranches",
        method: "get",
      })
      .then((res) => {
        return res.data;
      });
  },
  // 添加分部
  addBranch: (data) => {
    return axios
      .request({
        url: "api/postal/addBranch",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },

  // 删除分部
  removeBranch: (data) => {
    return axios
      .request({
        url: "api/postal/deleteBranch/" + data,
        method: "get",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 查询分部
  searchBranch: (data) => {
    return axios
      .request({
        url: "api/postal/searchArea",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
};
